import { render, staticRenderFns } from "./NewsletterSignup.vue?vue&type=template&id=ef816738&scoped=true&"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js&"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSignup.vue?vue&type=style&index=0&id=ef816738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef816738",
  null
  
)

export default component.exports